export default __webpack_public_path__ + "static/media/united-states-of-america.2f4d5f69.svg";